import React from "react";
import { Stack } from "@mui/material";

import { HubFilterMenu, HubFilterTimeMenu } from "../../components";
import { FOUNDRIES } from "../../constants";
import { useStationListWithCache } from "../../components/StationHookFormSelect";

const OutsideFilters = ({ defaultLocation = 1 }) => {
  const { stations = [] } = useStationListWithCache();
  const STATIONS = stations?.filter((s) => s.department.id === 6);
  return (
    <Stack direction="row" gap="5px">
      <HubFilterMenu
        id="location"
        icon="MapPin"
        options={FOUNDRIES}
        menuLabel="Filter By Location"
        label="Location"
        defaultValue={defaultLocation}
        multiSelect={false}
      />
      <HubFilterMenu
        id="stations"
        icon="Archive"
        options={STATIONS}
        menuLabel="Filter By Station"
        label="Station"
        useDefault={false}
      />
      <HubFilterTimeMenu id="startDate" label="Start Date" icon="Calendar" />
    </Stack>
  );
};

export default OutsideFilters;
